import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';

const customConfig = defineConfig({
    theme: {
        tokens: {
            colors: {
                yellow: {
                    600: { value: '#ddb837' },
                    700: { value: '#b79726' },
                },
                gray: {
                    500: { value: '#797C7F' },
                },
            },
        },
    },
});

export const system = createSystem(defaultConfig, customConfig);
